module.exports = __webpack_public_path__ + "ca45928c34a1497eb6dd683fed999ad1.png";